<template>

  <div class="wrapper" id="app">
    <!-- CARD WITH VERTICAL ICON TABS -->

    <div class="vx-col w-full ">
      <div class="vx-row mb-6">
        <div class="vx-col w-full lg:w-3/5">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full">
                <h4>Formas de pago</h4>

                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="interval" vs-value="mes" @change="changePlanSelected(monthlyPlan)">Cargo mensual</vs-radio>
                  </li>
                  <li>
                    <vs-radio v-model="interval" vs-value="año" @change="changePlanSelected(yearlyPlan)">Cargo anual (<span
                      class="text-primary">10% de descuento</span>)
                    </vs-radio>
                  </li>
                </ul>
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col lg:w-2/5">
          <vx-card>
            <h3 class="text-center text-primary">Resumen</h3>
            <div class="vx-row  ">
              <div class="vx-col lg:w-1/2 text-right">
                <h4 class="pt-5 d-inline-block font-w-600 ">Total: </h4>
              </div>
              <div class="vx-col lg:w-1/2 text-left">
                <h4 class="pt-5 d-inline-block ">${{ interval === "mes" ? planSelected.price_per_renew.toLocaleString('en-US') : (planSelected.price_per_renew * ((100 - planSelected.discount) / 100)).toLocaleString('en-US') }}/{{
                    interval
                  }}</h4>
              </div>
            </div>
          </vx-card>

        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full lg:w-3/5 mb-10">

          <vx-card>
            <div>
              <div class="vx-row">
                <div class="vx-col lg:w-1/2 mt-4">
                  <h4 v-if="isCardMethod">Pago con tarjeta</h4>
                  <h4 v-if="isSpeiMethod">Transferencia interbancaria</h4>
                </div>
                <div class="vx-col lg:w-1/2 ">
                  <span :class="{'border-pay-active padding-card overflow-visible border-primary  vs-button d-inline-block mr-4': isCardMethod,
                   'border-pay padding-card2 border-primary  vs-button d-inline-block mr-4': !isCardMethod}"
                        @click="btnCard">
                    <img :src="require('@/assets/images/company-logos/card.svg')" width="62" alt="">
                    <feather-icon v-if="isCardMethod" icon="CheckIcon" class="check-pay"
                                  svgClasses="w-5 h-5 p-ab back-border text-white p-unset"/>
                  </span>

                  <span v-if="interval === 'año'"
                    :class="{'border-pay-active padding-spei overflow-visible border-primary vs-button d-inline-block  mr-4': isSpeiMethod,
                   'border-pay padding-spei border-primary vs-button d-inline-block mr-4': !isSpeiMethod}"
                    @click="btnSpei">
                   <img :src="require('@/assets/images/company-logos/spei.svg')" width="45" alt="">
                   <feather-icon v-if="isSpeiMethod" icon="CheckIcon" class="check-pay2"
                                 svgClasses="w-5 h-5 p-ab back-border text-white p-unset"/>
                 </span>


                </div>
              </div>
              <div v-if="isCardMethod" :toggle-tab="toggleTab">
                <div class="vx-row">
                  <div class="vx-col w-full w-1400-100 xl:w-1/2 mt-4">
                    <label for="cardNumber" class="card-input__label">Número de la tarjeta</label>
                    <input type="text" id="cardNumber" class="card-input__input" placeholder="1234-1234-1234-1234"
                           v-mask="generateCardNumberMask" v-model="cardNumber" v-on:focus="focusInput"
                           v-on:blur="blurInput" data-ref="cardNumber" autocomplete="off">
                  </div>

                  <div class="vx-col w-full w-1400-100 xl:w-1/2 mt-4">
                    <label for="cardName" class="card-input__label">Titular de tarjeta </label>
                    <input type="text" id="cardName" class="card-input__input" v-model="cardName"
                           v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardName" autocomplete="off">
                  </div>
                </div>
                <div class="card-input">
                </div>
                <div class="card-input">
                </div>
                <div class="card-form__row">
                  <div class="card-form__col">
                    <div class="card-form__group">
                      <label for="cardMonth" class="card-input__label">Fecha de expiración</label><br>
                      <select class="card-input__input -select" id="cardMonth" v-model="cardMonth"
                              v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate">
                        <option value="" disabled selected>Mes</option>
                        <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth"
                                v-bind:key="n">
                          {{ n < 10 ? '0' + n : n }}
                        </option>
                      </select>
                      <select class="card-input__input -select" id="cardYear" v-model="cardYear" v-on:focus="focusInput"
                              v-on:blur="blurInput" data-ref="cardDate">
                        <option value="" disabled selected>Año</option>
                        <br>
                        <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">
                          {{ $index + minCardYear }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="card-form__col -cvv">
                    <div class="card-input">
                      <label for="cardCvv" class="card-input__label">CVV</label>
                      <input type="text" class="card-input__input" id="cardCvv" v-mask="'####'" maxlength="4"
                             v-model="cardCvv" v-on:focus="flipCard(true)" v-on:blur="flipCard(false)"
                             autocomplete="off">
                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-1/2 ">
                    <div class=" d-flex">
                      <img :src="require('@/assets/images/card/type/visa.svg')" width="55" class="mx-3" alt="">
                      <img :src="require('@/assets/images/card/type/master_2.svg')" width="45" class="mx-3" alt="">
                      <img :src="require('@/assets/images/card/type/american.svg')" width="45" class="mx-3" alt="">
                    </div>
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-button color="primary" class="float-right" @click="submitPaymentMethod">Pagar ahora</vs-button>
                  </div>
                </div>
              </div>


              <div v-if="isSpeiMethod" :toggle-tab="toggleTab">
                <div class="vx-row mt-4">
                  <div class="vx-col w-full">
                    <ol>
                      <li>Accede a tu banca en línea.</li>
                      <li>Da de alta la CLABE que aparece en la ficha. <strong>El banco deberá de ser STP</strong>.</li>
                      <li>Realiza la transferencia correspondiente por la cantidad exacta mostrada en la ficha, <strong>de
                        lo contrario se rechazará el cargo</strong>.
                      </li>
                      <li>Al confirmar tu pago, el portal de tu banco generará un comprobante digital. <strong>En el
                        podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de
                        pago.
                      </li>
                    </ol>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-button color="primary" class="float-right" @click="submitBuyWithSpei">Generar refencia
                    </vs-button>
                  </div>
                </div>

              </div>


            </div>
          </vx-card>
        </div>

        <div class="card-form2 vx-col lg:w-2/5">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">

                <feather-icon icon="AwardIcon"
                              class="p-4 mb-6 bg-primary inline-flex rounded-full text-white shadow mr-5"
                              svgClasses="h-5 w-5"></feather-icon>
                <h2 class="mb-6 text-white d-inline-block ">Beneficios</h2>

                <div class="mt-3">
                  <ul class="list pl-5 pr-3 mt-text text-white">
                    <li class="list__item ">
                      <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                        <feather-icon icon="CheckIcon" class="top-3 text-white"
                                      svgClasses="w-5 h-5 text-white"></feather-icon>
                      </span>
                      <span class="text-left">
                      {{ planSelected.credits_per_renew.toLocaleString('en-US') }} Firmas al {{ intervalDetail }}
                      </span>
                    </li>
                    <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-4 text-white"
                                svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                  Funcionalidades avanzadas

                  <ul>
                  <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-white"
                                     svgClasses="w-3 h-3 text-white"></feather-icon>
                    </span>
                    Firma ordenada
                  </li>
                  <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-white"
                                     svgClasses="w-3 h-3 text-white"></feather-icon>
                    </span>
                    Validación de RFC o CURP de firmantes
                  </li>
                     <li class="list__item">
                    <span class="w-5 h-5 mr-1 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-white"
                                     svgClasses="w-3 h-3 text-white"> </feather-icon>
                    </span>
                     Hoja de firmas con logo  o sin el logo de Verificamex
                  </li>

                    <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-white"
                                     svgClasses="w-3 h-3 text-white"> </feather-icon>
                    </span>
                    Recordatorios personalizados
                  </li>
                </ul>
                </span>

                    </li>

                    <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-4" svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                  Soporte preferente
                <vx-tooltip text="Vía chat, correo y teléfono" class="d-inline-block" position="top">
                  <feather-icon icon="HelpCircleIcon" class="top-4 text-primary"
                                svgClasses="w-5 h-5 text-white"></feather-icon>
                </vx-tooltip>
                </span>
                    </li>
                    <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-white"
                                svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                  Disfruta de un 20% de descuento en firmas adicionales
                </span>
                    </li>

                    <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-white"
                                svgClasses="w-5 h-5 text-white"></feather-icon>
                </span>
                      <span class="text-left">
                  Cargo recurrente
                </span>
                    </li>

                  </ul>
                </div>
              </vx-card>
            </div>

            <div class="vx-col w-full lg:w-1/2">

            </div>
          </div>
        </div>


        <div class="vx-col w-full mt-5">
          <div class="vx-row  card-form__inner bg-text-grey">
            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Por qué solicitamos tu tarjeta?</h3>
                <p class="mt-3">
                  Solicitamos los datos de tu tarjeta para prevenir que tu suscripción sea interrumpida después de la
                  prueba grauita. Tu suscripción puede ser cancelada cuando tu quieras antes de tu fecha de cobro.
                </p>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Qué tan fácil es cancelar?</h3>
                <p class="mt-3">
                  Puedes cancelar cuando tu quieras, envíanos un email cuando desees a <a
                  href="mailto:cancelacion@verificamex.com">cancelacion@verificamex.com</a>.
                </p>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/3">
              <div class="p-2">
                <h3>¿Qué pasará después?</h3>
                <p class="mt-3">
                  Serás redirigido al incio y ya tendrás habilidatas todas las funciones de Usuarios Avanzados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>

import router from "../../../../router";
import {AVAILABLE_PLANS, CONEKTA_API_KEY} from "../../../../config/app";

export default {
  props: [
    'planDetail', 'intervalDetail', 'isSubscription'
  ],
  data() {
    return {
      tabIndex: 1,
      planSelectedRadio: null,
      radios1: '1',
      currentCardBackground: Math.floor(Math.random() * 25 + 1), // just for fun :D
      cardName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      interval: "",
      monthlyPlan: AVAILABLE_PLANS.professional_monthly,
      yearlyPlan: AVAILABLE_PLANS.professional_yearly
    }
  },
  created() {
    if (this.planDetail && this.intervalDetail) {
      this.interval = this.intervalDetail;
      this.$store.dispatch("plans/getAll", {});
    } else {
      router.push('/');
    }
  },
  mounted() {
    this.cardNumberTemp = this.otherCardMask;
    const script = document.createElement('script')
    script.src = 'https://cdn.conekta.io/js/latest/conekta.js'
    script.async = true
    document.body.appendChild(script)
  },
  computed: {
    planData() {
      return this.$store.state.plans.plan.data;
    },
    planSelected() {
      console.log(this.planSelectedRadio);
      return this.planSelectedRadio !== null ? this.planData.filter(plan => plan.id === this.planSelectedRadio)[0] : this.planDetail
    },
    proPlanData() {
      return this.planData ? this.planData[1] : '';
    },
    isCardMethod() {
      return this.tabIndex === 1;
    },
    isSpeiMethod() {
      return this.tabIndex === 2;
    },

    getCardType() {
      let number = this.cardNumber;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return "visa"; // default type
    },
    generateCardNumberMask() {
      return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    }
  },
  watch: {
    cardYear() {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    }
  },
  methods: {
    changePlanSelected(id) {
      this.planSelectedRadio = id;
      this.tabIndex = 1;
    },
    toggleTab(index) {
      this.tabIndex = index;
    },

    btnCard() {
      this.tabIndex = this.tabIndex = 1;
    },
    btnSpei() {
      this.tabIndex = this.tabIndex = 2;
    },

    submitPaymentMethod() {
      window.Conekta.setPublicKey(CONEKTA_API_KEY);
      const tokenParams = {
        card: {
          number: this.cardNumber,
          name: this.cardName,
          exp_year: this.cardYear,
          exp_month: this.cardMonth,
          cvc: this.cardCvv
        }
      };
      window.Conekta.Token.create(tokenParams, token => {
        this.$store.dispatch("paymentMethods/addCard", {tokenId: token.id}).then(
          () => {
            this.switchPlan();
          }
        )
      }, error => {
        this.$store.dispatch("alert/error", error.message_to_purchaser);
      });
    },
    switchPlan() {
      this.$vs.loading({type: "point"})
      this.$store.dispatch("plans/switchPlan", {planId: this.planSelected.id, paymentMethod: "CARD_METHOD", aclChangeRole: this.$acl.change})
        .then(
          () => {
            this.$vs.loading.close()
            this.$store.dispatch("alert/success", "El plan se ha cambiado éxitosamente", {root: true});
            setTimeout(() => {
              router.push("/buy/success");
            }, 100)
          },
          error => {
            this.$vs.loading.close()
            this.$store.dispatch("alert/error", error, {root: true});
          }
        )
    },
    submitBuyWithSpei() {
      this.$vs.loading({type: "point"})
      this.$store.dispatch("plans/switchPlan", {planId: this.planSelected.id, paymentMethod: "SPEI_METHOD", aclChangeRole: this.$acl.change})
        .then(
          result => {
            this.$vs.loading.close()
            this.$store.dispatch("alert/success", "Se ha descargado tu ficha de pago", {root: true});
            this.downloadBuySheet(result.file);
          },
          error => {
            this.$vs.loading.close()
            this.$store.dispatch("alert/error", error, {root: true});
          }
        )
    },
    downloadBuySheet(file) {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:application/pdf;base64," + file; //Image Base64 Goes here
      a.download = "Ficha de pago.pdf"; //File name Here
      a.click(); //Downloaded file
    },
    flipCard(status) {
      this.isCardFlipped = status;
    },
    focusInput(e) {
      this.isInputFocused = true;
      let targetRef = e.target.dataset.ref;
      let target = this.$refs[targetRef];
      this.focusElementStyle = {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      }
    },
    blurInput() {
      let vm = this;
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null;
        }
      }, 300);
      vm.isInputFocused = false;
    }
  },

}
</script>

<style lang="scss">

.wrapper {
  min-height: 100vh;
  display: flex;

}

@media screen and (max-width: 700px), (max-height: 500px) {
  .wrapper {
    flex-wrap: wrap;
    flex-direction: column;
  }
}

.card-form2 {
  width: 100%;
}

@media screen and (max-width: 576px) {
  .card-form {
    margin: 0 auto;
  }
}

.card-form__inner {
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 35px;
  padding-top: 35px;
}

@media screen and (max-width: 480px) {
  .card-form__inner {
    padding: 25px;
    padding-top: 165px;
  }
}

@media screen and (max-width: 360px) {
  .card-form__inner {
    padding: 15px;
    padding-top: 165px;
  }
}

.card-form__row {
  display: flex;
  align-items: flex-start;
}

@media screen and (max-width: 480px) {
  .card-form__row {
    flex-wrap: wrap;
  }
}

.card-form__col {
  flex: auto;
  margin-right: 35px;
}

.card-form__col:last-child {
  margin-right: 0;
}

@media screen and (max-width: 480px) {
  .card-form__col {
    margin-right: 0;
    flex: unset;
    width: 100%;
    margin-bottom: 20px;
  }
  .card-form__col:last-child {
    margin-bottom: 0;
  }
}

.card-form__col.-cvv {
  max-width: 150px;
}

@media screen and (max-width: 480px) {
  .card-form__col.-cvv {
    max-width: initial;
  }
}

.card-form__group {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.card-form__group .card-input__input {
  flex: 1;
  margin-right: 15px;
}

.card-form__group .card-input__input:last-child {
  margin-right: 0;
}

.card-form__button {
  width: 100%;
  height: 55px;
  background: #4514c7;
  border: none;
  border-radius: 5px;
  font-size: 22px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 3px 10px 20px 0px rgba(0, 0, 0, 0.3);
  color: #fff;
  margin-top: 20px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-form__button {
    margin-top: 10px;
  }
}

.card-item {
  max-width: 430px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item {
    max-width: 310px;
    height: 220px;
    width: 90%;
  }
}

@media screen and (max-width: 360px) {
  .card-item {
    height: 180px;
  }
}

.card-item.-active .card-item__side.-front {
  transform: perspective(1000px) rotateY(180deg) rotateX(0deg) rotateZ(0deg);
}

.card-item.-active .card-item__side.-back {
  transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
}

.card-item__focus {
  position: absolute;
  z-index: 3;
  border-radius: 5px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.65);
}

.card-item__focus:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #08142f;
  height: 100%;
  border-radius: 5px;
  filter: blur(25px);
  opacity: 0.5;
}

.card-item__focus.-active {
  opacity: 1;
}

.card-item__side {
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.25);
  transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
  transform-style: preserve-3d;
  transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  backface-visibility: hidden;
  height: 100%;
}

.card-item__side.-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
  z-index: 2;
  padding: 0;
  height: 100%;
}

.card-item__side.-back .card-item__cover {
  transform: rotateY(-180deg);
}

.card-item__bg {
  max-width: 100%;
  display: block;
  max-height: 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.card-item__cover {
  height: 100%;
  background-color: #1c1d27;
  position: absolute;
  height: 100%;
  background-color: #1c1d27;
  left: 0;
  top: 0;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
}

.card-item__cover:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(6, 2, 29, 0.45);
}

.card-item__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 0 10px;
}

@media screen and (max-width: 480px) {
  .card-item__top {
    margin-bottom: 25px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__top {
    margin-bottom: 15px;
  }
}

.card-item__chip {
  width: 60px;
}

@media screen and (max-width: 480px) {
  .card-item__chip {
    width: 50px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__chip {
    width: 40px;
  }
}

.card-item__type {
  height: 45px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  max-width: 100px;
  margin-left: auto;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__type {
    height: 40px;
    max-width: 90px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__type {
    height: 30px;
  }
}

.card-item__typeImg {
  max-width: 100%;
  object-fit: contain;
  max-height: 100%;
  object-position: top right;
}

.card-item__info {
  color: #fff;
  width: 100%;
  max-width: calc(100% - 85px);
  padding: 10px 15px;
  font-weight: 500;
  display: block;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__info {
    padding: 10px;
  }
}

.card-item__holder {
  opacity: 0.7;
  font-size: 13px;
  margin-bottom: 6px;
}

@media screen and (max-width: 480px) {
  .card-item__holder {
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.card-item__wrapper {
  font-family: "Source Code Pro", monospace;
  padding: 25px 15px;
  position: relative;
  z-index: 4;
  height: 100%;

  text-shadow: 7px 6px 10px rgba(0, 0, 0, 0.8);
  user-select: none;
}

@media screen and (max-width: 480px) {
  .card-item__wrapper {
    padding: 20px 10px;
  }
}

.card-item__name {
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

@media screen and (max-width: 480px) {
  .card-item__name {
    font-size: 16px;
  }
}

.card-item__nameItem {
  display: inline-block;
  min-width: 8px;
  position: relative;
}

.card-item__number {
  font-weight: 500;
  line-height: 1;
  color: #fff;
  font-size: 27px;
  margin-bottom: 35px;
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__number {
    font-size: 21px;
    margin-bottom: 15px;
    padding: 10px 10px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__number {
    font-size: 19px;
    margin-bottom: 10px;
    padding: 10px 10px;
  }
}

.card-item__numberItem {
  width: 16px;
  display: inline-block;
}

.card-item__numberItem.-active {
  width: 30px;
}

@media screen and (max-width: 480px) {
  .card-item__numberItem {
    width: 13px;
  }
  .card-item__numberItem.-active {
    width: 16px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__numberItem {
    width: 12px;
  }
  .card-item__numberItem.-active {
    width: 8px;
  }
}

.card-item__content {
  color: #fff;
  display: flex;
  align-items: flex-start;
}

.card-item__date {
  flex-wrap: wrap;
  font-size: 18px;
  margin-left: auto;
  padding: 10px;
  display: inline-flex;
  width: 80px;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__date {
    font-size: 16px;
  }
}

.card-item__dateItem {
  position: relative;
}

.card-item__dateItem span {
  width: 22px;
  display: inline-block;
}

.card-item__dateTitle {
  opacity: 0.7;
  font-size: 13px;
  padding-bottom: 6px;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__dateTitle {
    font-size: 12px;
    padding-bottom: 5px;
  }
}

.card-item__band {
  background: rgba(0, 0, 19, 0.8);
  width: 100%;
  height: 50px;
  margin-top: 30px;
  position: relative;
  z-index: 2;
}

@media screen and (max-width: 480px) {
  .card-item__band {
    margin-top: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__band {
    height: 40px;
    margin-top: 10px;
  }
}

.card-item__cvv {
  text-align: right;
  position: relative;
  z-index: 2;
  padding: 15px;
}

.card-item__cvv .card-item__type {
  opacity: 0.7;
}

@media screen and (max-width: 360px) {
  .card-item__cvv {
    padding: 10px 15px;
  }
}

.card-item__cvvTitle {
  padding-right: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 5px;
}

.card-item__cvvBand {
  height: 45px;
  background: #fff;
  margin-bottom: 30px;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #1a3b5d;
  font-size: 18px;
  border-radius: 4px;
  box-shadow: 0px 10px 20px -7px rgba(0, 0, 0, 0.35);
}

@media screen and (max-width: 480px) {
  .card-item__cvvBand {
    height: 40px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__cvvBand {
    margin-bottom: 15px;
  }
}

.card-list {
  margin-bottom: -130px;
}

@media screen and (max-width: 480px) {
  .card-list {
    margin-bottom: -120px;
  }
}

.card-input {
  margin-bottom: 20px;
}

.card-input__label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
  color: #1a3b5d;
  width: 100%;
  display: block;
  user-select: none;
}

.card-input__input {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  box-shadow: none;
  border: 1px solid #ced6e0;
  transition: all 0.3s ease-in-out;
  font-size: 18px;
  padding: 5px 15px;
  background: none;
  color: #1a3b5d;
  font-family: "Source Sans Pro", sans-serif;
}

.card-input__input:hover, .card-input__input:focus {
  border-color: #4514c7;
}

.card-input__input:focus {
  box-shadow: 0px 10px 20px -13px rgba(0, 0, 0, 0.35);
}

.card-input__input.-select {
  -webkit-appearance: none;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC");
  background-size: 12px;
  background-position: 90% center;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}

.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}

.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}

.slide-fade-right-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}

.slide-fade-right-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-right-enter {
  opacity: 0;
  transform: translateX(10px) rotate(45deg);
  pointer-events: none;
}

.slide-fade-right-leave-to {
  opacity: 0;
  transform: translateX(-10px) rotate(45deg);
  pointer-events: none;
}

.github-btn {
  position: absolute;
  right: 40px;
  bottom: 50px;
  text-decoration: none;
  padding: 15px 25px;
  border-radius: 4px;
  box-shadow: 0px 4px 30px -6px rgba(0, 0, 0, 0.65);
  background: #24292e;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 16px;
  text-align: center;
  transition: all .3s ease-in-out;
}

@media screen and (min-width: 500px) {
  .github-btn:hover {
    transform: scale(1.1);
    box-shadow: 0px 17px 20px -6px rgba(0, 0, 0, 0.36);
  }
}

@media screen and (max-width: 700px) {
  .github-btn {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 20px;
  }
  .github-btn:active {
    transform: scale(1.1);
    box-shadow: 0px 17px 20px -6px rgba(0, 0, 0, 0.36);
  }
}


.bg-text-grey {
  background: #f2f2f2 !important;
}

.greet-user {
  position: relative;

  .decore-left {
    position: absolute;
    left: 0;
    top: 0;
  }

  .decore-right {
    position: absolute;
    right: 0;
    top: 0;
  }
}

@media screen and (max-width: 1350px) {
  .w-1400-100 {
    width: 100% !important;
  }
}

ol {
  list-style: none;
  counter-reset: my-awesome-counter;
}

ol li {
  counter-increment: my-awesome-counter;
}

ol li::before {
  content: counter(my-awesome-counter) ". ";
  color: #4514c7;

}

</style>

